const reducePageContent = (page) => {
  const pageContent =
    page.content &&
    page.content.reduce((accu, content) => {
      const nameOrTitle = content.contentful_id || "placeholder"
      const name = content.template ? content.template : nameOrTitle
      return { ...accu, [name]: content.section_content || content }
    }, {})

  return pageContent
}

export default reducePageContent
